import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../../services/workplace.service';
import {
    FolderWorkplaceGridItemObject,
    FolderWorkplaceGridObject,
} from '@libs/types/src/services/object-type/folder-workplace.object';
import { map } from 'rxjs/operators';

interface State {
    folderWorkplaces: FolderWorkplaceGridObject | null;
}

const defaultState: State = {
    folderWorkplaces: null,
};

@Injectable()
export class CreatePersonPageWorkplaceTableStore extends ComponentStoreFactory<State> {

    public readonly folderWorkplaces$ = this.data.folderWorkplaces$.pipe(
        map((grid) => grid ? ({
            ...grid,
            items: grid.items.map((item: FolderWorkplaceGridItemObject) => ({
                ...item,
                __hideDetail: item.workplaceDeleted,
                __hideDelete: item.workplaceDeleted,
            })),
        }) : null),
    );

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
    }

}
